import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  organizationDetails: {
    country: '',
    state: '',
    city: '',
    postalCode: '',
    addressLineOne: '',
    addressLineTwo: '',
    organizationName: '',
    businessType: '',
    industry: '',
    companySize: 0,
    businessRegistrationNumber: '',
    companyWebsite: '',
    companyBusinessEmail: '',
    companyLogo: '',
    companyLinkedinProfile: '',
    designation: '',
    companyProfile: '',
    companyTaxId: '',
  },
  allOrgUsers: [],
  adminData: {},
  allOrgManagers: [],
  allLicences: [],
  allRoles: [],
  roleList: [],
  managersList: [],
  allTeams: [],
  isDataFetched: false,
};

const organizationSlice = createSlice({
  name: 'organizationDetails',
  initialState,
  reducers: {
    setOrganizationDetails: (state, action) => {
      state.organizationDetails = {
        ...state.organizationDetails,
        ...action.payload,
      };
    },
    saveOrgDetails(state, action) {
      state.organizationDetails = action.payload;
    },
    saveAllOrgUsers(state, action) {
      state.allOrgUsers = action.payload;
    },
    saveAllOrgManagers(state, action) {
      state.allOrgManagers = action.payload;
    },
    saveAllRoles(state, action) {
      state.allRoles = action.payload;
    },
    saveAllLicences(state, action) {
      state.allLicences = action.payload;
    },
    saveAllTeams(state, action) {
      state.allTeams = action.payload;
    },
    saveIsDataFetched(state, action) {
      state.isDataFetched = action.payload;
    },
    saveRoleList(state, action) {
      state.roleList = action.payload;
    },
    saveManagerList(state, action) {
      state.managersList = action.payload;
    },
    saveAdminData(state, action) {
      state.adminData = action.payload;
    },
    resetOrganizationDetails: () => initialState,
  },
});

export const {
  setOrganizationDetails,
  resetOrganizationDetails,
  saveAllOrgUsers,
  saveAllOrgManagers,
  saveAllRoles,
  saveAllLicences,
  saveAllTeams,
  saveOrgDetails,
  saveIsDataFetched,
  saveRoleList,
  saveManagerList,
  saveAdminData,
} = organizationSlice.actions;
export default organizationSlice.reducer;
